import React, { useState } from "react";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import './Analisedash.css';

const HEADER_HEIGHT = 56;

const Analisedash = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const kpis = [
    { title: 'Total Enviados', value: '1.245', icon: 'bi-envelope', trend: '+12%', color: '#0d6efd' },
    { title: 'Entregues', value: '1.120', icon: 'bi-check-circle', trend: '+8%', color: '#198754' },
    { title: 'Falhas', value: '45', icon: 'bi-exclamation-circle', trend: '-5%', color: '#dc3545' },
    { title: 'Taxa de Abertura', value: '89%', icon: 'bi-graph-up', trend: '+3%', color: '#0dcaf0' },
  ];

  const recent = [
    { id: 1, nome: 'Campanha Junho', enviado: 320, entregues: 300, falhas: 5, data: '02/06/2025', status: 'Concluída' },
    { id: 2, nome: 'Campanha Julho', enviado: 210, entregues: 198, falhas: 7, data: '15/07/2025', status: 'Concluída' },
    { id: 3, nome: 'Promo Agosto', enviado: 715, entregues: 622, falhas: 33, data: '01/08/2025', status: 'Em andamento' },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar: preserva estrutura original */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width: window.innerWidth <= 768 ? (sidebarOpen ? '80vw' : 56) : (sidebarOpen ? 220 : 70),
          maxWidth: window.innerWidth <= 768 ? (sidebarOpen ? 260 : 56) : (sidebarOpen ? 220 : 70),
          minWidth: window.innerWidth <= 768 ? 56 : (sidebarOpen ? 220 : 70),
          background: '#005c53',
          minHeight: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
          transition: 'width 0.3s',
          alignItems: 'center',
          boxShadow: window.innerWidth <= 768 && sidebarOpen ? '4px 0 16px rgba(0,0,0,0.18)' : '2px 0 8px rgba(0,0,0,0.10)',
          overflowX: 'hidden',
        }}
      >
        <div style={{ width: '100%', display: 'flex', flexDirection: sidebarOpen ? 'row' : 'column', justifyContent: sidebarOpen ? 'space-between' : 'center', alignItems: 'center', padding: sidebarOpen ? '16px' : '24px 0 8px 0' }}>
          {sidebarOpen ? (
            <a href="/app"><img src={LogoCompleta} alt="Logo" style={{ height: 40 }} /></a>
          ) : (
            <a href="/app"><img src={LogoIcone} alt="Logo" style={{ height: 32, width: 32 }} /></a>
          )}

          <button onClick={() => setSidebarOpen(s => !s)} className="btn btn-link text-white" style={{ fontSize: 22, padding: 0 }}>
            <i className={`bi ${sidebarOpen ? 'bi-x-lg' : 'bi-list'}`} />
          </button>
        </div>

        <ul className="nav nav-pills flex-column mb-auto w-100" style={{ alignItems: sidebarOpen ? 'flex-start' : 'center', paddingBottom: 0 }}>
          <li className="nav-item w-100">
            <a href="/app" className="nav-link d-flex align-items-center" style={{ justifyContent: sidebarOpen ? 'flex-start' : 'center', padding: sidebarOpen ? '8px 16px' : '8px 0', width: '100%', background: '#51a197', color: '#fff', fontWeight: 'bold', borderRadius: 8 }}>
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: '#fff' }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Dashboard</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: '0.5rem 0' }} /></li>
          <li className="w-100">
            <a href="/campanha" className="nav-link text-white d-flex align-items-center" style={{ justifyContent: sidebarOpen ? 'flex-start' : 'center', padding: sidebarOpen ? '8px 16px' : '8px 0', width: '100%' }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22, color: '#fff' }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Campanhas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: '0.5rem 0' }} /></li>
          <li className="w-100">
            <a href="/Projetos" className="nav-link text-white d-flex align-items-center" style={{ justifyContent: sidebarOpen ? 'flex-start' : 'center', padding: sidebarOpen ? '8px 16px' : '8px 0', width: '100%' }}>
              <i className="bi bi-folder2-open" style={{ fontSize: 22, color: '#fff' }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Meus Projetos</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: '0.5rem 0' }} /></li>
          <li className="w-100">
            <a href="/Contas" className="nav-link text-white d-flex align-items-center" style={{ justifyContent: sidebarOpen ? 'flex-start' : 'center', padding: sidebarOpen ? '8px 16px' : '8px 0', width: '100%' }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22, color: '#fff' }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: '0.5rem 0' }} /></li>
          <li className="w-100">
            <a href="/Operacoes" className="nav-link text-white d-flex align-items-center" style={{ justifyContent: sidebarOpen ? 'flex-start' : 'center', padding: sidebarOpen ? '8px 16px' : '8px 0', width: '100%' }}>
              <i className="bi bi-gear" style={{ fontSize: 22, color: '#fff' }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: '0.5rem 0' }} /></li>
          <li className="w-100">
            <a href="/Blacklist" className="nav-link text-white d-flex align-items-center" style={{ justifyContent: sidebarOpen ? 'flex-start' : 'center', padding: sidebarOpen ? '8px 16px' : '8px 0', width: '100%' }}>
              <i className="bi bi-person-x" style={{ fontSize: 22, color: '#fff' }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Blacklist</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: '0.5rem 0' }} /></li>
          <li className="w-100">
            <a href="/Webhook" className="nav-link text-white d-flex align-items-center" style={{ justifyContent: sidebarOpen ? 'flex-start' : 'center', padding: sidebarOpen ? '8px 16px' : '8px 0', width: '100%' }}>
              <i className="bi bi-link-45deg" style={{ fontSize: 22, color: '#fff' }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Webhook</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: '0.5rem 0' }} /></li>
        </ul>
      </nav>

      {/* Header: preserva estrutura original */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: HEADER_HEIGHT, background: '#005c53', zIndex: 1200 }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: 'margin-left 0.3s' }}>
          <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 18 }}>Análise</span>
        </div>

        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a href="#" className="nav-link d-flex align-items-center p-0" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ color: '#fff', cursor: 'pointer' }}>
              <i className="bi bi-person-circle" style={{ fontSize: 28 }} />
              <span className="d-none d-lg-inline ms-2" style={{ padding: '6px 16px', borderRadius: 16, display: 'inline-block' }}>Nome do Usuário</span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li><a className="dropdown-item" href="#">Perfil</a></li>
              <li><a className="dropdown-item" href="#">Configurações</a></li>
              <li><a className="dropdown-item" href="#">Sair</a></li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Corpo da página — AQUI SÓ MELHORIAS VISUAIS, mantendo header/sidebar intactos */}
      <div className="main-dashboard-content" style={{ marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0, paddingTop: HEADER_HEIGHT, width: window.innerWidth > 768 ? (sidebarOpen ? 'calc(100% - 220px)' : 'calc(100% - 70px)') : '100vw', transition: 'margin-left 0.3s' }}>
        <div className="container-fluid p-4">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
            <div>
              <h2 style={{ margin: 0, color: '#023c36' }}>Análise</h2>
              <div style={{ color: '#6c757d', fontSize: 13 }}>Visão geral de campanhas e desempenho</div>
            </div>
            
          </div>

          {/* Filtros aprimorados */}
          <div className="filters" style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 22, flexWrap: 'wrap' }}>
            <div className="filter-group" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <label style={{ fontSize: 13, color: '#495057', marginRight: 8 }}>Período</label>
              <div className="filter-row" style={{ display: 'flex', gap: 8 }}>
                <input type="date" className="form-control" style={{ maxWidth: 160, borderRadius: 8 }} />
                <input type="date" className="form-control" style={{ maxWidth: 160, borderRadius: 8 }} />
              </div>
            </div>

            <select className="form-select" style={{ maxWidth: 220, borderRadius: 8 }}>
              <option>Todos os projetos</option>
              <option>Campanha A</option>
            </select>

          </div>

          {/* KPI Cards modernizados */}
          <div className="row g-3 mb-4">
            {kpis.map((k, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-3">
                <div style={{ background: '#fff', padding: 18, borderRadius: 12, boxShadow: '0 6px 20px rgba(8,24,44,0.04)', border: '1px solid #eef3f4', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 6, fontWeight: 600 }}>{k.title}</div>
                    <div style={{ fontSize: 26, fontWeight: 700, color: '#023c36' }}>{k.value}</div>
                    <div style={{ fontSize: 12, color: k.color, marginTop: 8, fontWeight: 700 }}>{k.trend}</div>
                  </div>
                  <div style={{ width: 52, height: 52, borderRadius: 10, background: k.color + '15', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className={`bi ${k.icon}`} style={{ fontSize: 22, color: k.color }} />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Charts and side KPIs */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-lg-8">
              <div style={{ background: '#fff', padding: 20, borderRadius: 12, boxShadow: '0 6px 20px rgba(8,24,44,0.04)', border: '1px solid #eef3f4' }}>
                <h6 style={{ marginBottom: 20, color: '#023c36', fontWeight: 600 }}>Desempenho por período</h6>
                <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#adb5bd', background: '#f8f9fa', borderRadius: 8 }}>📊 Gráfico (a integrar)</div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div style={{ background: '#fff', padding: 20, borderRadius: 12, boxShadow: '0 6px 20px rgba(8,24,44,0.04)', border: '1px solid #eef3f4' }}>
                <h6 style={{ marginBottom: 12, color: '#023c36', fontWeight: 600 }}>KPIs detalhados</h6>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #e9ecef' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#495057' }}><i className="bi bi-check-circle" style={{ color: '#198754' }} /> Taxa de Entrega</span>
                    <span style={{ fontWeight: 600, color: '#023c36' }}>90%</span>
                  </li>
                  <li style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #e9ecef' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#495057' }}><i className="bi bi-hand-index" style={{ color: '#0dcaf0' }} /> Taxa de Cliques</span>
                    <span style={{ fontWeight: 600, color: '#023c36' }}>12%</span>
                  </li>
                  <li style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#495057' }}><i className="bi bi-exclamation-circle" style={{ color: '#dc3545' }} /> Taxa de Falha</span>
                    <span style={{ fontWeight: 600, color: '#023c36' }}>3.6%</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

         
              
        
          

        </div>
      </div>

    </div>
  );
};

export default Analisedash;
